<template>
  <div>
    <div style="margin-top: -24px; margin-left: 15px">
      <el-input
        size="small"
        style="width: 400px"
        placeholder="输入文件名查询"
        @keyup.enter="handleSearchByText"
        v-model="searchText"
      >
        <template #append>
          <el-button @click="handleSearchByText"
            ><i class="iconfont icon-sousuo"></i> <span>查询</span></el-button
          >
        </template>
      </el-input>
    </div>
    <div v-loading="loading" class="table-wrapper">
      <el-table
        :data="tableData"
        @sort-change="handleSortChange"
        height="calc(100vh - 260px)"
        size="default"
        :row-class-name="tableRowClassName"
        border
      >
        <el-table-column width="66">
          <template #default="scope">
            <el-button
              @click="handleRowClick(scope.row)"
              link
              type="primary"
              size="small"
              style="padding: 0"
            >
              <i class="iconfont icon-level-down"></i>
              <span>查看</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="asset_path" label="文件"> </el-table-column>
        <el-table-column
          prop="bundle_name"
          label="所在ab包"
          sortable="custom"
          width="110"
        >
        </el-table-column>
        <el-table-column
          prop="inverse_dependencies_assets"
          label="被引用数"
          width="110"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="dependencies_assets"
          label="引用数"
          width="100"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="dependencies_bundles"
          label="总依赖AB包"
          width="140"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="directboundnum"
          label="直接依赖AB包"
          width="140"
          sortable="custom"
        >
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination
          background
          :page-size="count"
          :current-page="cursor"
          :total="total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script setup>
import { apiPackageParseAsset } from "@/Api/AppApi";
import { ref, defineEmits, defineProps, onMounted } from "vue";

const props = defineProps(["param"]);
const emit = defineEmits(["selectRow"]);

onMounted(() => {
  loadData();
});

const searchText = ref("");
const count = ref(30);
const cursor = ref(1);
const total = ref(0);
function handleSearchByText() {
  count.value = 30;
  cursor.value = 1;
  loadData(searchText.value);
}

let preABName = "";
let preRowColor = "singular";
function tableRowClassName({ row }) {
  if (preABName !== row.bundle_name) {
    preABName = row.bundle_name;
    if (preRowColor === "singular") {
      preRowColor = "evennumber";
    } else {
      preRowColor = "singular";
    }
  }
  return preRowColor;
}

let sortColumn = "";
let order = "";
function handleSortChange(event) {
  sortColumn = event.prop;
  order = event.order;
  loadData(searchText.value);
}

function handleRowClick(row) {
  const data = {
    viewType: "assetsdetail",
    name: row.asset_path,
  };
  emit("selectRow", data);
}

function handlePageChange(pagenum) {
  cursor.value = pagenum;
  loadData(searchText.value);
}

const tableData = ref([]);

const loading = ref(false);
async function loadData(search) {
  const params = {
    version_id: props.param.versionid,
    cursor: cursor.value,
    count: count.value,
  };

  if (search != undefined && search.length > 0) {
    params.asset_path = search;
  }
  if (sortColumn != undefined && sortColumn.length > 0) {
    params.sort_field = sortColumn;
  }
  if (order != undefined && order.length > 0) {
    params.order = order;
  }

  loading.value = true;
  const res = await apiPackageParseAsset(params);
  loading.value = false;

  if (res.code === 0) {
    tableData.value = res.data.list;
    total.value = res.data.total;
  }
}
</script>
<style lang="scss" scoped>
.table-wrapper {
  margin-top: 8px;
  width: 100%;
  background: #fff;
  padding: 15px 15px 0 15px;
  height: calc(100vh - 190px);

  :deep() {
    .el-table__inner-wrapper,
    .el-scrollbar__wrap {
      height: 100% !important;
    }

    .el-table__body-wrapper {
      height: calc(100% - 40px) !important;
    }
  }
}

.pagination-wrapper {
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  padding: 5px 0;
  height: 46px;
}
</style>
<style>
.el-table .singular {
  background: #dcdcdc;
}

.el-table .evennumber {
  background: #ffffff;
}
</style>
